module.exports = __webpack_public_path__ + "img/office-building.e2fafd63.svg";